<template>
  <div>
    <!-- 新增/编辑-： -->
    <el-dialog :title="isAdd ? $t('message.add') : $t('message.compile')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1080px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 商品链接 -->
          <el-form-item :label="$t('message.ProductLink') + '：'" prop="link">
            <div class="row">
              <input v-model="ruleForm.link" :disabled="!isAdd" @keyup.enter="goodsParticulars" />
              <el-button type="primary" @click="goodsParticulars" v-if="isAdd">获取商品信息</el-button>
            </div>
          </el-form-item>
          <!-- 商品ID -->
          <el-form-item :label="$t('message.goodsID') + '：'">
            {{ ruleForm.goods_id }}
          </el-form-item>
          <!-- 商品图片 -->
          <el-form-item :label="$t('message.productPicture') + '：'">
            <el-image style="width: 100px; height: 100px" :src="ruleForm.pic" :preview-src-list="[ruleForm.pic]">
            </el-image>
          </el-form-item>
          <!-- 底价填写 -->
          <el-form-item :label="$t('message.basePriceEntry') + '：'">
            <div class="table">
              <ol>
                <li class="flex05">NO</li>
                <li class="flex05">
                  <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
                </li>
                <!-- 属性组合 -->
                <li class="flex4">{{ $t('message.attributeCombination') }}</li>
                <!-- 协议底价 -->
                <li>{{ $t('message.agreedBasePrice') }}</li>
              </ol>
              <ul v-for="(item, index) in ruleForm.detail_list" :key="index">
                <li class="flex05">{{ index + 1 }}</li>
                <li class="flex05">
                  <el-checkbox v-model="item.checked" @change="singleSelection"></el-checkbox>
                </li>
                <!-- 属性组合 -->
                <li class="flex4">
                  <span v-for="(prop, propIndex) in item.prop" :key="propIndex">{{ prop.key }} : {{ prop.value }};
                  </span>
                </li>
                <!-- 协议底价 -->
                <li><el-input v-model="item.price" @input="handleInput(item)"></el-input></li>
              </ul>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="goodsPriceConfigStore" v-if="isAdd">
          {{ $t("message.ok") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="goodsPriceConfigUpdate" v-else>
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      isAdd: true,
      ruleForm: {
        link: '',
        goods_id: '',
        mi_id: '',
        pic: '',
        from_platform: '',
        detail_list: [],
      },
      dialogVisible: false,
      checked: false,
      rules: {
        link: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 新增
    goodsPriceConfigStore() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.goodsPriceConfigStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.goodsPriceConfigList()
          });
        }
      })

    },
    // 修改
    goodsPriceConfigUpdate() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.goodsPriceConfigUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.goodsPriceConfigList()
          });
        }
      })
    },
    // 默认数据
    acceptData(data, isAdd) {
      this.ruleForm = data
      this.dialogVisible = true
      this.isAdd = isAdd
    },
    // 商品链接
    goodsParticulars() {
      this.$api.goodsUrlToGoodsId({ goods_url: this.ruleForm.link }).then(res => {
        const miId = res.data.mi_id || ''
        let timestamp = Math.floor(new Date().valueOf() / 1000)
        let sign = 'wakanda forever!@9523`'
        let datas = {
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: miId,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        };
        this.$api.orderApi.goodsParticulars(datas).then((res) => {
          console.log(res);
          let goodsInfo = res.data.goodsInfo
          this.ruleForm.goods_id = res.data.goodsId
          this.ruleForm.mi_id = res.data.mi_id || res.data.miId || miId
          this.ruleForm.pic = res.data.images[0]
          this.ruleForm.from_platform = res.data.fromPlatform
          this.ruleForm.detail_list = []
          // this.ruleForm.detail_list.push()
          goodsInfo.goodsInventory.forEach(item => {
            let obj = {
              sku_id: item.valueC[0].skuId,
              checked: false,
              price: '',
              prop: []
            }
            let keyArr = item.keyC.split('㊖㊎')
            keyArr.forEach((key, keyIndex) => {
              obj.prop.push({
                key: goodsInfo.specification[keyIndex].keyC,
                value: key
              })
            })
            this.ruleForm.detail_list.push(obj)
          })
        });
      })

    },
    // 全选
    allChecked() {
      this.ruleForm.detail_list.forEach(item => {
        item.checked = this.checked
      })
    },
    //单选
    singleSelection() {
      this.checked = this.ruleForm.detail_list.every(item => item.checked)
      this.$forceUpdate()
    },
    // 是否输入的小数
    handleInput(item) {
      item.price = ("" + item.price) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,3})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到3位小数
      if (item.checked) {
        this.ruleForm.detail_list.forEach(itemData => {
          if (itemData.checked) {
            itemData.price = item.price
          }
        })
      }

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;

    input {
      flex: 1;
      border: 1px solid #DCDF;
      padding: 10px 15px;
      border-radius: 4px;
      font-size: 14px;
      color: #606266;
    }

    .el-button {
      margin-left: 20px;
    }
  }

  .table {
    max-height: 300px;
    overflow-y: auto;

    ol {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 9;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex4 {
      flex: 4;
    }
  }
}
</style>
